<template>
  <v-container fluid class="pa-7">
    <v-row v-if="analysis != null">
      <v-col cols="12" xl="6" lg="6" md="6">
        <v-card class="rounded-lg" elevation="3">
          <v-card-text>
            <v-row>
              <v-col>
                <v-row>
                  <v-col cols="12">
                    <span
                      class="
                        text-subtitle-2
                        text-sm-subtitle-1
                        text-md-subtitle-1
                        text-lg-subtitle-1
                        text-xl-subtitle-1
                      "
                    >
                      {{ translations.label_analysis_folio }}
                      {{ this.$route.params.folio }} -
                      {{
                        code == 2
                          ? translations.analysisTypes["MONITORING"]
                          : translations.analysisTypes["INITIAL"]
                      }}
                    </span>
                  </v-col>
                  <v-col>
                    <v-row>
                      <v-col>
                        <v-btn
                          color="primary"
                          small
                          block
                          :outlined="!isMedition"
                          @click="changeAnalysis('medition')"
                          >{{ translations.label_measurement }}</v-btn
                        >
                      </v-col>
                      <v-col v-if="valuation">
                        <v-btn
                          color="primary"
                          small
                          block
                          :outlined="!isValuation"
                          @click="changeAnalysis('valuation')"
                          >{{ translations.label_valuation }}</v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col cols="12" class="row justify-end pr-0 pt-5">
                    <div
                      v-if="
                        analysis.type === 'INITIAL' &&
                          analysis.status === 'VALUATED'
                      "
                    >
                      <v-icon color="primary">mdi-check-all</v-icon>
                    </div>
                    <div
                      v-else-if="
                        (analysis.type === 'INITIAL' ||
                          analysis.type === 'Initial') &&
                          analysis.status !== 'VALUATED'
                      "
                    >
                      <v-icon color="accent">mdi-timer-sand</v-icon>
                    </div>
                    <div
                      v-else-if="
                        (analysis.type === 'MONITORING' ||
                          analysis.type === 'Monitoring') &&
                          analysis.status === 'MEASURED'
                      "
                    >
                      <v-icon color="primary">mdi-check-all</v-icon>
                    </div>
                    <div
                      v-else-if="
                        (analysis.type === 'MONITORING' ||
                          analysis.type === 'Monitoring') &&
                          analysis.status !== 'MEASURED'
                      "
                    >
                      <v-icon color="primary">mdi-timer-sand</v-icon>
                    </div>

                    <span
                      v-if="
                        analysis.type === 'INITIAL' ||
                          analysis.type === 'Initial'
                      "
                      :class="
                        analysis.status === 'VALUATED'
                          ? 'primary--text'
                          : 'accent--text'
                      "
                      >{{ getStatus(analysis.status) }}</span
                    >
                    <span
                      v-if="
                        analysis.type === 'MONITORING' ||
                          analysis.type === 'Monitoring'
                      "
                      :class="
                        analysis.status === 'MEASURED'
                          ? 'primary--text'
                          : 'accent--text'
                      "
                      >{{ getStatus(analysis.status) }}</span
                    >
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="text-end">
                    <span>{{ getFormattedSimple(analysis.date) }}</span>
                  </v-col>
                </v-row>
                <v-row v-if="pdf.length > 0">
                  <v-col cols="12" class="text-end">
                    <v-icon color="primary" @click="downloadPDF">
                      mdi-file-download
                    </v-icon>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-autocomplete
                  outlined
                  background-color="white"
                  clearable
                  dense
                  v-model="sample_selected"
                  :items="samples"
                  item-text="name"
                  @change="changeSample"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <div v-if="measureSelected">
              <v-row>
                <v-col cols="12" class="py-1">
                  <span class="primary--text font-weight-bold"
                    >{{ translations.label_irrigation_unit }}:</span
                  ><span class="ml-2">{{ measureSelected.areaName }}</span>
                </v-col>
                <v-col cols="12" class="py-1">
                  <span class="primary--text font-weight-bold"
                    >{{ translations.label_crop_cycle }}:</span
                  ><span class="ml-2">{{
                    setCropName(measureSelected.crop)
                  }}</span>
                </v-col>
                <v-col cols="12" class="row"></v-col>
              </v-row>
              <v-row>
                <v-col>
                  <MapSampleSmall :sample="measureSelected.sample" />
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" xl="6" lg="6" md="6" v-if="isMedition">
        <v-card
          class="rounded-lg d-flex"
          elevation="3"
          height="690"
          v-if="measureSelected"
        >
          <v-card-text class="overflow-y-auto ma-2">
            <v-row>
              <v-col>
                <span
                  class="
                    primary--text
                    font-weight-bold
                    text-subtitle-2
                    text-sm-subtitle-1
                    text-md-subtitle-1
                    text-lg-subtitle-1
                    text-xl-subtitle-1
                  "
                  >{{ translations.label_soil_health_parameters }}</span
                >
              </v-col>
            </v-row>
            <v-row
              v-if="measureSelected.pCTests"
              justify="center"
              class="text-center"
            >
              <v-col cols="12" v-if="measureSelected.pCTests.ph">
                <span class="primary--text">pH:</span>
                <span class="black--text ml-2">{{
                  measureSelected.pCTests.ph
                }}</span>
              </v-col>
              <v-col cols="12" v-if="measureSelected.pCTests.organicMaterial">
                <span class="primary--text"
                  >% {{ translations.label_organic_matter }}:</span
                >
                <span class="black--text ml-2">{{
                  measureSelected.pCTests.organicMaterial
                }}</span>
              </v-col>
              <v-col cols="12" v-if="measureSelected.pCTests.labileCarbon">
                <span class="primary--text"
                  >{{ translations.label_carbon_capture_pox }}:</span
                >
                <span class="black--text ml-2">{{
                  measureSelected.pCTests.labileCarbon
                }}</span>
              </v-col>
              <v-col cols="12" v-if="measureSelected.pCTests.texture">
                <span class="primary--text"
                  >{{ translations.label_soil_texture }}:</span
                >
                <span class="black--text ml-2">{{
                  measureSelected.pCTests.texture
                }}</span>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col align="center">
                <span
                  class="
                    primary--text
                    font-weight-bold
                    text-subtitle-2
                    text-sm-subtitle-1
                    text-md-subtitle-1
                    text-lg-subtitle-1
                    text-xl-subtitle-1
                  "
                  >{{ translations.label_biological_capital_measurement }}</span
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <span class="primary--text font-weight-bold">
                  {{ translations.label_soil_beneficials_of_interest }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <span>{{ translations.label_microorganism }} </span>
              </v-col>
              <v-col cols="5" class="d-flex flex-column">
                <span>{{ translations.label_taxonomic_identification }}</span>
              </v-col>
              <v-col cols="3" align="end">
                <span v-if="hasMolecular">UMC</span>
                <span v-else>{{ translations.label_concentration }}</span>
              </v-col>
            </v-row>
            <div
              v-if="
                measureSelected.microbiological.beneficials &&
                  measureSelected.microbiological.beneficials.length > 0
              "
            >
              <v-row
                v-for="(item, index) of measureSelected.microbiological
                  .beneficials"
                :key="index"
                class="mt-2"
              >
                <v-col cols="4" class="py-1">
                  <span class="black--text font-weight-bold font-italic">
                    {{ getMoType(item.moType) }}
                  </span>
                </v-col>
                <v-col cols="5" class="py-1">
                  <span
                    v-if="item.possibleThreat"
                    class="accent--text font-weight-bold font-italic"
                    >{{ item.name }}</span
                  >
                  <span
                    v-else
                    class="black--text font-weight-bold font-italic"
                    >{{ item.name }}</span
                  >
                </v-col>

                <v-col cols="3" class="py-1" align="end">
                  <span class="font-weight-bold pr-2" v-if="item.umc">{{
                    item.cq
                  }}</span>
                  <span class="font-weight-bold pr-2" v-else>{{
                    item.interpretation
                  }}</span>
                  <v-tooltip top color="primary" v-if="!hasMolecular">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" color="primary" class=""
                        >mdi-information</v-icon
                      >
                    </template>
                    <span class="font-weight-bold">{{
                      item.concentration
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <div v-else>
              <v-row>
                <v-col class="text-center">
                  <span class="font-weight-bold">{{
                    translations.label_no_beneficials
                  }}</span>
                </v-col>
              </v-row>
            </div>

            <v-row class="mt-5">
              <v-col>
                <span class="primary--text font-weight-bold">
                  {{ translations.label_soil_pathogen_detection }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <span>{{ translations.label_microorganism }} </span>
              </v-col>
              <v-col cols="5" class="d-flex flex-column">
                <span>{{
                  this.translations.label_taxonomic_identification
                }}</span>
              </v-col>
              <v-col cols="3" align="end">
                <span v-if="hasMolecular">UMC</span>
                <span v-else>{{ translations.label_concentration }}</span>
              </v-col>
            </v-row>
            <div
              v-if="
                measureSelected.microbiological.threats &&
                  measureSelected.microbiological.threats.length > 0
              "
            >
              <v-row
                v-for="(item, index) of measureSelected.microbiological.threats"
                :key="index"
                class="mt-2"
              >
                <v-col cols="4" class="py-1">
                  <span class="black--text font-weight-bold font-italic">
                    {{ getMoType(item.moType) }}
                  </span>
                </v-col>
                <v-col cols="5" class="py-1">
                  <span class="accent--text font-weight-bold font-italic">{{
                    item.name
                  }}</span>
                </v-col>

                <v-col cols="3" class="py-1" align="end">
                  <span class="font-weight-bold pr-2" v-if="item.umc"
                    >{{ item.cq }}
                  </span>
                  <span class="font-weight-bold pr-2" v-else>{{
                    item.interpretation
                  }}</span>
                  <v-tooltip top color="primary" v-if="!hasMolecular">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" color="primary" class=""
                        >mdi-information</v-icon
                      >
                    </template>
                    <span class="font-weight-bold">{{
                      item.concentration
                    }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
            <div v-else>
              <v-row>
                <v-col class="text-center">
                  <span class="font-weight-bold">{{
                    translations.label_no_pathogens
                  }}</span>
                </v-col>
              </v-row>
            </div>
            <div v-if="measureSelected.microbiological.notDetecteds">
              <v-row class="mt-5">
                <v-col>
                  <span class="primary--text font-weight-bold">
                    {{ translations.label_not_detected }}
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="4">
                  <span>{{ translations.label_microorganism }} </span>
                </v-col>
                <v-col cols="5" class="d-flex flex-column">
                  <span>
                    {{ translations.label_taxonomic_identification }}
                  </span>
                </v-col>
                <v-col cols="3" align="center">
                  <span>{{ translations.label_type }}</span>
                </v-col>
              </v-row>
              <div
                v-if="measureSelected.microbiological.notDetecteds.length > 0"
              >
                <v-row
                  v-for="(item, index) of measureSelected.microbiological
                    .notDetecteds"
                  :key="index"
                  class="mt-2"
                >
                  <v-col cols="4" class="py-1">
                    <span class="black--text font-weight-bold font-italic">
                      {{ getMoType(item.moType) }}
                    </span>
                  </v-col>
                  <v-col cols="5" class="py-1">
                    <span
                      v-if="
                        item.possibleThreat || item.possibleThreat == undefined
                      "
                      class="accent--text font-weight-bold font-italic"
                      >{{ item.name }}</span
                    >
                    <span
                      v-else
                      class="black--text font-weight-bold font-italic"
                      >{{ item.name }}</span
                    >
                  </v-col>

                  <v-col cols="3" class="py-1" align="center">
                    <span
                      class="font-weight-bold accent--text"
                      v-if="
                        item.possibleThreat || item.possibleThreat == undefined
                      "
                      >{{ translations.label_pathogen }}</span
                    >
                    <span class="font-weight-bold black--text" v-else>{{
                      translations.label_beneficial
                    }}</span>
                    <!-- <v-tooltip top color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          class=""
                          >mdi-information</v-icon
                        >
                      </template>
                      <span class="font-weight-bold"
                        >{{ item.concentration }} juveniles/100g</span
                      >
                    </v-tooltip> -->
                  </v-col>
                </v-row>
              </div>
              <div v-else>
                <v-row>
                  <v-col class="text-center">
                    <span class="font-weight-bold">{{
                      translations.label_no_not_detected
                    }}</span>
                  </v-col>
                </v-row>
              </div>
            </div>
            <!-- <v-row class="mt-2" v-if="this.hasMolecular">
              <v-col>
                <span class="font-weight-bold black--text">
                  *Este dato semicuantitativo de la técnica molecular se
                  recomienda sea usado solo para comparar entre tratamientos
                  enuna misma unidad agrícola e interpretado por el ingeniero de
                  campo.NOTA: MIENTRAS MÁS BAJO EL NUMERO SIGNIFICA QUE HAY
                  MAYOR CANTIDAD DE MICROORGANISM
                </span>
              </v-col>
            </v-row> -->
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" xl="6" lg="6" md="6" v-if="isValuation">
        <v-card class="rounded-lg d-flex" elevation="3" height="690">
          <v-tabs v-if="valuation">
            <v-tab
              v-if="valuation.regionalized && valuation.regionalized.length > 0"
            >
              {{ translations.label_soil_disease_control }}
            </v-tab>
            <v-tab-item
              v-if="valuation.regionalized && valuation.regionalized.length > 0"
            >
              <v-card class="rounded-lg d-flex" elevation="0" height="690">
                <v-card-text class="overflow-y-auto ma-2">
                  <v-row
                    v-for="(item, index) of valuation.regionalized"
                    :key="index + item.isolate.name"
                  >
                    <v-col xl="3" lg="4" md="5" sm="5">
                      <span class="accent--text">{{
                        translations.label_control
                      }}</span>
                      <v-spacer></v-spacer>
                      <span class="accent--text font-weight-bold font-italic">{{
                        item.isolate.name
                      }}</span>

                      <v-img
                        :src="item.isolate.img"
                        contain
                        height="200px"
                        width="200px"
                      >
                      </v-img>
                    </v-col>
                    <v-col xl="8" lg="8" md="6" sm="6">
                      <carousel
                        :perPage="getWidth"
                        :navigationEnabled="true"
                        :navigationClickTargetSize="4"
                        :minSwipeDistance="1"
                        :paginationEnabled="false"
                      >
                        <slide
                          v-for="(control, index) of item.confrontations"
                          :key="index + control.name"
                        >
                          <v-card max-width="90%" elevation="0">
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <v-img
                                    :src="control.img"
                                    contain
                                    height="200"
                                    width="200"
                                  ></v-img>
                                </v-col>
                                <v-col cols="12">
                                  <v-row>
                                    <v-col cols="12" class="pb-0">
                                      <span class="accent--text">{{
                                        item.isolate.name
                                      }}</span>
                                      <span class="black--text">
                                        vs {{ control.name }}</span
                                      >
                                    </v-col>
                                    <v-col cols="12" class="pt-0">
                                      <span class="black--text"
                                        >{{ control.percentage }}% - </span
                                      ><span>{{ control.bioControl }}</span>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </slide>
                      </carousel>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab v-if="this.valuation.nutritionTests">{{
              translations.label_nutrition
            }}</v-tab>
            <v-tab-item v-if="this.valuation.nutritionTests">
              <v-card class="rounded-lg d-flex" elevation="0" height="690">
                <v-card-text class="overflow-y-auto ma-2">
                  <v-row
                    v-if="
                      this.valuation.nutritionTests.phosphorus &&
                        this.valuation.nutritionTests.phosphorus.length > 0
                    "
                  >
                    <v-col xl="3" lg="4" md="5" sm="5">
                      <span class="accent--text">{{
                        translations.label_negative_control
                      }}</span>
                      <v-spacer></v-spacer>
                      <span class="accent--text font-weight-bold font-italic">
                        {{ translations.label_phosphorus_solubilization }}</span
                      >

                      <v-img
                        :src="negativeControlP.img"
                        contain
                        height="200px"
                        width="200px"
                      >
                      </v-img>
                    </v-col>
                    <v-col xl="8" lg="8" md="6" sm="6">
                      <carousel
                        :perPage="getWidth"
                        :navigationEnabled="true"
                        :navigationClickTargetSize="4"
                        :minSwipeDistance="1"
                        :paginationEnabled="false"
                      >
                        <slide
                          v-for="(phosphoru, index) of valuation.nutritionTests
                            .phosphorus"
                          :key="index + phosphoru.name"
                        >
                          <v-card max-width="90%" elevation="0">
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <v-img
                                    :src="phosphoru.img"
                                    contain
                                    height="200"
                                    width="200"
                                  ></v-img>
                                </v-col>
                                <v-col cols="12">
                                  <v-row>
                                    <v-col cols="12" class="pb-0">
                                      <span class="accent--text"></span>
                                    </v-col>
                                    <v-col cols="12" class="pt-0">
                                      <span class="black--text"
                                        >{{ phosphoru.name }} - </span
                                      ><span>{{
                                        phosphoru.solubilization
                                          ? phosphoru.solubilization
                                          : 0
                                      }}</span>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </slide>
                      </carousel>
                    </v-col>
                  </v-row>

                  <v-row
                    v-if="
                      this.valuation.nutritionTests.potasium &&
                        this.valuation.nutritionTests.potasium.length > 0
                    "
                  >
                    <v-col xl="3" lg="4" md="5" sm="5">
                      <span class="accent--text">{{
                        translations.label_negative_control
                      }}</span>
                      <v-spacer></v-spacer>
                      <span class="accent--text font-weight-bold font-italic">
                        {{ translations.label_potassium_solubilization }}</span
                      >

                      <v-img
                        :src="negativeControlF.img"
                        contain
                        height="200px"
                        width="200px"
                      >
                      </v-img>
                    </v-col>
                    <v-col xl="8" lg="8" md="6" sm="6">
                      <carousel
                        :perPage="getWidth"
                        :navigationEnabled="true"
                        :navigationClickTargetSize="4"
                        :minSwipeDistance="1"
                        :paginationEnabled="false"
                      >
                        <slide
                          v-for="(phosphoru, index) of valuation.nutritionTests
                            .potasium"
                          :key="index + phosphoru.name"
                        >
                          <v-card max-width="90%" elevation="0">
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <v-img
                                    :src="phosphoru.img"
                                    contain
                                    height="200"
                                    width="200"
                                  ></v-img>
                                </v-col>
                                <v-col cols="12">
                                  <v-row>
                                    <v-col cols="12" class="pb-0">
                                      <span class="accent--text"></span>
                                    </v-col>
                                    <v-col cols="12" class="pt-0">
                                      <span class="black--text"
                                        >{{ phosphoru.name }} - </span
                                      ><span>{{
                                        phosphoru.solubilization
                                          ? phosphoru.solubilization
                                          : 0
                                      }}</span>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </slide>
                      </carousel>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab
              v-if="
                this.valuation.biostimulationTests &&
                  this.valuation.biostimulationTests.siderophores &&
                  this.valuation.biostimulationTests.siderophores.length > 0
              "
              >{{ translations.label_siderophores }}</v-tab
            >
            <v-tab-item
              v-if="
                this.valuation.biostimulationTests &&
                  this.valuation.biostimulationTests.siderophores &&
                  this.valuation.biostimulationTests.siderophores.length > 0
              "
            >
              <v-card class="rounded-lg d-flex" elevation="0" height="690">
                <v-card-text class="overflow-y-auto ma-2">
                  <v-row>
                    <v-col xl="3" lg="4" md="5" sm="5">
                      <span class="accent--text">{{
                        translations.label_negative_control
                      }}</span>
                      <v-spacer></v-spacer>
                      <span class="accent--text font-weight-bold font-italic">
                        {{ translations.label_siderophores }}</span
                      >

                      <v-img
                        :src="negativeControlS.img"
                        contain
                        height="200px"
                        width="200px"
                      >
                      </v-img>
                    </v-col>
                    <v-col xl="8" lg="8" md="6" sm="6">
                      <carousel
                        :perPage="getWidth"
                        :navigationEnabled="true"
                        :navigationClickTargetSize="4"
                        :minSwipeDistance="1"
                        :paginationEnabled="false"
                      >
                        <slide
                          v-for="(siderophore, index) of valuation
                            .biostimulationTests.siderophores"
                          :key="index + siderophore.name"
                        >
                          <v-card max-width="90%" elevation="0">
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <v-img
                                    :src="siderophore.img"
                                    contain
                                    height="200"
                                    width="200"
                                  ></v-img>
                                </v-col>
                                <v-col cols="12">
                                  <v-row>
                                    <v-col cols="12" class="pb-0">
                                      <span class="accent--text"></span>
                                    </v-col>
                                    <v-col cols="12" class="pt-0">
                                      <span class="black--text"
                                        >{{ siderophore.name }} - </span
                                      ><span>{{
                                        siderophore.solubilization
                                          ? siderophore.solubilization
                                          : 0
                                      }}</span>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </slide>
                      </carousel>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>

            <v-tab
              v-if="
                this.valuation.biostimulationTests &&
                  this.valuation.biostimulationTests.cellulolytic &&
                  this.valuation.biostimulationTests.cellulolytic.length > 0
              "
            >
              {{ translations.label_cellulolytic_activity }}</v-tab
            >

            <v-tab-item
              v-if="
                this.valuation.biostimulationTests &&
                  this.valuation.biostimulationTests.cellulolytic &&
                  this.valuation.biostimulationTests.cellulolytic.length > 0
              "
            >
              <v-card class="rounded-lg d-flex" elevation="0" height="690">
                <v-card-text class="overflow-y-auto ma-2">
                  <v-row>
                    <v-col xl="3" lg="4" md="5" sm="5">
                      <span class="accent--text">{{
                        translations.label_negative_control
                      }}</span>
                      <v-spacer></v-spacer>
                      <span class="accent--text font-weight-bold font-italic">
                        {{ translations.label_cellulolytic_activity }}</span
                      >

                      <v-img
                        :src="negativeControlAC.img"
                        contain
                        height="200px"
                        width="200px"
                      >
                      </v-img>
                    </v-col>
                    <v-col xl="8" lg="8" md="6" sm="6">
                      <carousel
                        :perPage="getWidth"
                        :navigationEnabled="true"
                        :navigationClickTargetSize="4"
                        :minSwipeDistance="1"
                        :paginationEnabled="false"
                      >
                        <slide
                          v-for="(cellulolyti, index) of valuation
                            .biostimulationTests.cellulolytic"
                          :key="index + cellulolyti.name"
                        >
                          <v-card max-width="90%" elevation="0">
                            <v-card-text>
                              <v-row>
                                <v-col>
                                  <v-img
                                    :src="cellulolyti.img"
                                    contain
                                    height="200"
                                    width="200"
                                  ></v-img>
                                </v-col>
                                <v-col cols="12">
                                  <v-row>
                                    <v-col cols="12" class="pb-0">
                                      <span class="accent--text">{{
                                        cellulolyti.name
                                      }}</span>
                                    </v-col>
                                    <v-col cols="12" class="pt-0">
                                      <span class="black--text">CM - </span
                                      ><span>{{
                                        cellulolyti.interpretation
                                          ? cellulolyti.interpretation
                                          : 0
                                      }}</span>
                                    </v-col>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </slide>
                      </carousel>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab
              v-if="
                valuation.biostimulationTests &&
                  valuation.biostimulationTests.AIA
              "
            >
              AIA
            </v-tab>
            <v-tab-item
              v-if="
                valuation.biostimulationTests &&
                  valuation.biostimulationTests.AIA
              "
            >
              <v-card class="rounded-lg d-flex" elevation="0" height="690">
                <v-card-text class="overflow-y-auto ma-2">
                  <v-row
                    class="mb-5 mt-1"
                    v-if="AIAB.length > 0 || AIAF.length > 0"
                  >
                    <v-col v-if="AIAB.length > 0"
                      ><v-btn
                        color="primary"
                        dark
                        small
                        block
                        @click="changeAIA('bacteria')"
                        >{{ translations.label_bacteria }}</v-btn
                      ></v-col
                    >
                    <v-col v-if="AIAF.length > 0">
                      <v-btn
                        color="primary"
                        dark
                        small
                        block
                        @click="changeAIA('fungis')"
                        >{{ translations.label_fungi }}</v-btn
                      >
                    </v-col>
                  </v-row>
                  <Chart :results="AIA" />
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col cols="12" xl="6" lg="6" md="6">
        <v-card>
          <v-skeleton-loader
            type="table-heading, list-item-two-line, image, table-tfoot"
          ></v-skeleton-loader>
        </v-card>
      </v-col>
      <v-col cols="12" xl="6" lg="6" md="6">
        <v-card>
          <v-skeleton-loader
            type="table-heading, list-item-two-line, image, table-tfoot"
          ></v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
    <!-- copyright -->
    <v-footer class="text-caption text-center d-flex justify-center" fixed>
      D.R. © Solena Ag, Inc. {{new Date().getFullYear()}}
    </v-footer>
  </v-container>
</template>

<script>
//vuex
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
//libraries
import moment from "moment";
//components
import MapSampleSmall from "../components/territory/MapSampleSmall.vue";
import { Carousel, Slide } from "vue-carousel";
import Chart from "../components/territory/chart";
import AlertVue from "../components/Alert.vue";
export default {
  components: {
    MapSampleSmall,
    Carousel,
    Slide,
    Chart,
  },
  data: () => ({
    negativeControlP: null,
    negativeControlF: null,
    negativeControlS: null,
    negativeControlAC: null,
    AIA: [],
    AIAF: [],
    AIAB: [],
    num_per_page: 2,
    model: null,
    slides: ["", "", "", ""],
    isMedition: true,
    isValuation: false,
    isLoadData: false,
    pdf: "",
    measure: null,
    valuation: null,
    code: "",
    analysis: null,
    samples: [],
    sample_selected: null,
    measureSelected: null,
    hasMolecular: false,
  }),
  async created() {
    try {
      let response = await this.getResults(this.$route.params.folio);
      if (response) {
        this.hasMolecular = response.hasMolecular;
        this.pdf = response.url;
        this.measure = response.results_measure;
        this.valuation = response.results_valuation;
        if (this.valuation) {
          if (this.valuation.nutritionTests) {
            if (
              this.valuation.nutritionTests.phosphorus &&
              this.valuation.nutritionTests.phosphorus.length > 0
            ) {
              this.negativeControlP = this.valuation.nutritionTests.phosphorus[0];
              this.valuation.nutritionTests.phosphorus.shift();
            }
            if (
              this.valuation.nutritionTests.potasium &&
              this.valuation.nutritionTests.potasium.length > 0
            ) {
              this.negativeControlF = this.valuation.nutritionTests.potasium[0];
              this.valuation.nutritionTests.potasium.shift();
            }
          }

          if (this.valuation.biostimulationTests) {
            if (this.valuation.biostimulationTests.siderophores) {
              this.negativeControlS = this.valuation.biostimulationTests.siderophores[0];
              this.valuation.biostimulationTests.siderophores.shift();
            }
          }
          if (this.valuation.biostimulationTests) {
            if (this.valuation.biostimulationTests.cellulolytic) {
              this.negativeControlAC = this.valuation.biostimulationTests.cellulolytic[0];
              this.valuation.biostimulationTests.cellulolytic.shift();
            }
          }

          if (
            this.valuation.biostimulationTests &&
            this.valuation.biostimulationTests.AIA
          ) {
            for (let element of this.valuation.biostimulationTests.AIA) {
              if (element.mo === "bacteria") {
                this.AIAB.push(element);
              } else {
                this.AIAF.push(element);
              }
            }
            if (this.AIAB.length > 0) {
              this.AIA = this.AIAB;
            } else {
              this.AIA = this.AIAF;
            }
          }
        }
        this.code = response.code;
        this.analysis = response.analysis;
        for (let item of response.analysis.receptions) {
          this.samples.push({
            name: item.container.sample.soilArea.name,
            id: item.container.sample.soilArea._id,
          });
        }
        this.sample_selected = this.samples[0];
        await this.changeSample(this.samples[0].name);
      } else {
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text:
            "Algo salio mal al cargar detalle de resultados !!, intente de nuevo",
          timeout: 4000,
        });
      }
    } catch (e) {
      console.log(e);
      this.SET_ALERT_TYPE({
        visible: true,
        type: "error",
        text:
          "Algo salio mal al cargar detalle de resultados !!, intente de nuevo",
        timeout: 4000,
      });
    }
    this.SET_APPBAR_OPTIONS({
      leftButton: "back-arrow",
      funcLeftButton: this.goBack,
    });
  },
  computed: {
    ...mapGetters("session", ["currentTranslations"]),
    translations() {
      return this.currentTranslations;
    },
    ...mapState("areasList", ["crops"]),
    getWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 1;
          break;
        case "sm":
          return 1;
          break;
        case "md":
          return 1;
          break;
        case "lg":
          return 2;
          break;
        case "xl":
          return 2;
          break;
      }
    },
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapMutations(["SET_APPBAR_OPTIONS"]),
    ...mapActions("results", ["getResults"]),
    getFormattedSimple(date) {
      return moment(date).format("YYYY/MM/DD");
    },
    getStatus(value) {
      return this.translations.status_samples[value] || value;
    },
    getTyoe(value) {
      if (value === "INITIAL" || value === "Initial") {
        return this.translations.analysisTypes["INITIAL"];
      } else {
        return this.translations.analysisTypes["MONITORING"];
      }
    },
    setCropName(name) {
      return this.translations.crop_name_list[name] || name;
    },
    getMoType(item) {
      return this.translations.moTypes[item] || item;
    },
    async changeSample(value) {
      for (let item of this.measure.measure) {
        if (item.areaName === value) {
          this.measureSelected = item;
          break;
        }
      }
    },
    changeAnalysis(value) {
      switch (value) {
        case "medition":
          this.isMedition = true;
          this.isValuation = false;
          break;
        case "valuation":
          this.isMedition = false;
          this.isValuation = true;
          break;
      }
    },
    changeAIA(value) {
      if (value === "bacteria") {
        this.AIA = this.AIAB;
      } else {
        this.AIA = this.AIAF;
      }
    },
    goBack() {
      this.$router.back();
    },
    downloadPDF() {
      var a = document.createElement("a");
      a.href = this.pdf;
      let fileName = this.pdf.split("/").pop();
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(this.pdf);
      a.remove();
    },
  },
};
</script>

<style scoped>
.v-tab {
  text-transform: none !important;
}
</style>
